export enum TransferenceMode {
	NotTransfer = 1,
	Transfer = 2,
	NotTransferDefined = 3,
}
